import { API_ENDPOINT } from '@Env/variables';
import { Assigned } from '@Models/types';
import { JiraAssigned } from '@Models/types';
import { createAxiosInstance } from './axios';

export const jiraAnalyzerAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, API_ENDPOINT);

  const jiraAnalyzer = {
    getAnalyzerIssues: async (
      key: string,
      maxResults: number,
      dateFilter: string,
      nextPageToken?: string
    ): Promise<{
      issues: JiraAssigned[];
      nextPageToken?: string;
      isLast: boolean;
    }> => {
      const { data } = await axios.post('/api/getAnalyzerIssues', {
        prefix: key,
        maxResults: maxResults,
        dateFilter,
        nextPageToken,
      });

      return {
        issues: (data.issues as JiraAssigned[]) ?? [],
        nextPageToken: data.nextPageToken,
        isLast: data.isLast ?? false,
      };
    },

    tagTickets: async (tickets: Assigned[]): Promise<Assigned[]> => {
      const { data } = await axios.post('/api/taggedJiraTickets', {
        tickets,
      });
      return data.tagged;
    },
  };

  return jiraAnalyzer;
};
